/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	OrganisationAcceptInvitationPathParams,
	OrganisationAcceptInvitationResponse,
} from '../types/OrganisationAcceptInvitation'

/**
 * POST /organisations/invitations/:invitationId/accept
 * @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationController.php OrganisationController::acceptInvitation
 */
export async function organisationAcceptInvitation(
	invitationId: OrganisationAcceptInvitationPathParams['invitationId'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganisationAcceptInvitationResponse>> {
	return axiosInstance.post(`/organisations/invitations/${invitationId}/accept`, undefined, config)
}
